import { render, staticRenderFns } from "./children-requests.vue?vue&type=template&id=22bc0e18&"
import script from "./children-requests.vue?vue&type=script&lang=js&"
export * from "./children-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports